import { ResolveFn } from '@angular/router';
import { UserLocation } from '@dvm-monorepo/interfaces/keycloak';
import { inject } from '@angular/core';
import { UserLocationService } from '@app/features/user-locations/services/user-location.service';
import { AuthenticationService } from '@dvm-monorepo/frontend/services/authentication.service';
import { catchError, map, of } from 'rxjs';

export const userLocationsResolver: ResolveFn<UserLocation[]> = () => {
    const authenticationService = inject(AuthenticationService);
    const userLocationService = inject(UserLocationService);
    const userId = authenticationService.user()?.sub;

    if (!userId) {
        return [];
    }

    return userLocationService.getAllByUserId(userId).pipe(
        map(({ content }) => content),
        catchError(() => of([]))
    );
};
